export default __webpack_public_path__ + "static/media/endlessKnot.66a16ebf.png";